import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import { diasOptions } from "../utils/utils";
import moment from "moment";

const { Select2, Date, DateTime, Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];
function EditSeguro({ history, match }) {
  const dispatch = useDispatch();

  const modelEditSeguro = useSelector((state) => state.updateSeguro);
  const modelSeguroById = useSelector((state) => state.seguroById);

  const [id, setId] = useState(match.params.id);
  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(null);

  useEffect(() => {
    const data = modelEditSeguro?.data?.data;
    const error = modelEditSeguro?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckUpdateSeguro.actions.clear());
    }
    if (data) {
      history.push(`/seguros/${localId}`);
      dispatch(controller.duckUpdateSeguro.actions.clear());
    }
  }, [modelEditSeguro]);

  useEffect(() => {
    const data = modelSeguroById?.data?.data;
    const error = modelSeguroById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSeguroById.actions.clear());
    }
    if (data && data.data) {
      setNombre(data.data.nombre);
      setEstado(data.data.estado);
      setLocalId(data.data.localId);

      dispatch(controller.duckSeguroById.actions.clear());
    }
  }, [modelSeguroById]);

  useEffect(() => {
    dispatch(controller.getSeguroByIdThunk(match.params.id));
  }, []);

  function submit() {
    if (!nombre || !estado) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    let data = {
      _id: id,
      nombre,
      estado,
      localId,
    };

    dispatch(controller.updateSeguroThunk(data));
  }

  return (
    <Content title="Editar seguro" browserTitle="Editar seguro" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar seguro"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelEditSeguro.loading || modelSeguroById.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Nombre"
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default EditSeguro;
